






import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { Meter, ResCode, PowerConditionerTableData } from "@/api/baseDefine";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner
} from "@/api/meter";
import { formatDate, formatDateTime } from "../../utils/dateUtil";
@Component
export default class FirewareBatchUpgradeDialog extends Vue {
  @Prop({ default: null, required: true }) private meters!: Meter[];
  private firewareBatchUpgradeDialogShow: boolean = false;
  private clickShow() {
    if (this.meters.length != 1) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.onlyOneMeterSupport").toString(),
        type: "warning"
      });
      return;
    }
    this.firewareBatchUpgradeDialogShow = true;
  }
}
